import { useState } from 'react';

import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';
import { getLargestImage } from '../components/shared/logic/get-largest-image';
import { ComponentImage } from '../components/component-image';
import { ViewProps } from '../components/draw/draw.constants';
import SubActivityView from '../components/sub-activity/sub-activity-view';
import * as Styled from './activity-builder-image-lightbox.style';
import {
  DrawLightbox,
  DrawLightboxImage,
} from './activity-builder-draw-lightbox.style';

const ActivityBuilderDrawLightbox = ({
  id,
  type,
  properties,
  subActivityProperties,
}: ViewProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const image = properties.image;

  const { imageDimensions, setContainerElement } = useImageDimensionEffect({
    imageUrl: getLargestImage(image?.responsive || null),
    onComplete: () => setIsLoading(false),
  });

  return (
    <DrawLightbox>
      <SubActivityView
        withTTSButton
        componentId={id}
        componentType={type}
        subActivityDetails={subActivityProperties}
      />
      <Styled.ImageLightboxImage $isLoading={isLoading}>
        <DrawLightboxImage ref={setContainerElement}>
          <ComponentImage
            images={image?.responsive || []}
            altText={properties.altText || undefined}
            imageDimensions={imageDimensions}
          />
        </DrawLightboxImage>
      </Styled.ImageLightboxImage>
    </DrawLightbox>
  );
};

export default ActivityBuilderDrawLightbox;
